import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-member",
  "use": "icon-member-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-member\">\n<style type=\"text/css\">\n\t#icon-member .st0{fill:#333333;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M42.4,20.1L34.7,7.2C33.9,5.8,32.4,5,30.8,5H17.2c-1.6,0-3,0.8-3.9,2.2L5.6,20.1C5,21,5.1,22.2,5.9,23l17,19.5\n\t\tc0.3,0.3,0.7,0.5,1.1,0.5s0.8-0.2,1.1-0.5l17-19.5C42.9,22.2,43,21,42.4,20.1z M24,39.2L8.3,21.3l7.6-12.6C16.2,8.3,16.7,8,17.2,8\n\t\th13.6c0.5,0,1,0.3,1.3,0.7l7.6,12.6L24,39.2z\" />\n\t<path class=\"st0\" d=\"M23.9,30.3l-8.4-8.8c-0.6-0.6-1.5-0.6-2.1-0.1c-0.6,0.6-0.6,1.5-0.1,2.1l9.5,10c0.3,0.3,0.7,0.5,1.1,0.5\n\t\tc0,0,0,0,0,0c0.4,0,0.8-0.2,1.1-0.5l8.5-10c0.5-0.6,0.5-1.6-0.2-2.1c-0.6-0.5-1.6-0.5-2.1,0.2L23.9,30.3z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcons/svg/member.svg
// module id = GyY2
// module chunks = 35